import { Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FormGroup } from "@angular/forms";
import { FormFieldConfig } from "../../models/form-field-config";
import { IFormField } from "../../interfaces/iform-field";
import { FieldError } from "../../models/field-error";

@Component({
    selector: "wtf-form-radio",
    templateUrl: "./form-radio.component.html",
    styleUrls: ["./form-radio.component.scss"],
})
export class FormRadioComponent implements OnInit, IFormField {
    propertyName: string;
    optionsBehavior = new BehaviorSubject<any>(null);
    options = this.optionsBehavior.asObservable();
    rawListOptions: Array<any>;

    group: FormGroup;
    config: FormFieldConfig;

    idPropertyName: string;
    valuePropertyName: string;
    optionSelected: any;
    isVisible = true;
    inline = false;

    constructor() {}

    ngOnInit() {
        this.getOptions();

        if (this.config) {
            this.propertyName = this.config.fieldInfo.name;
            this.inline = this.config.fieldInfo.inline;
        }
    }

    getOptions() {
        if (this.config.options) {
            this.idPropertyName = this.config.options.idPropertyName;
            this.valuePropertyName = this.config.options.valuePropertyName;

            if (this.config.options.fixedOptions) {
                this.rawListOptions = this.config.options.fixedOptions;
                this.optionsBehavior.next(this.rawListOptions);
                this.setDefaultOption();
            }
        }
    }

    setDefaultOption() {
        if (this.config.fieldInfo.defaultValue && this.rawListOptions) {
            this.rawListOptions.forEach((item) => {
                if (
                    item[this.idPropertyName] ===
                    this.config.fieldInfo.defaultValue
                ) {
                    this.optionSelected = item;
                }
            });
        }
    }

    setObservableDataSource(data: any) {
        data.subscribe((res) => {
            this.rawListOptions = res;
            this.optionsBehavior.next(res);
        });
    }

    getErrorList(): FieldError[] {
        return null;
    }

    setVisible(isVisible: boolean) {
        this.isVisible = isVisible;
    }

    isControlVisible(): boolean {
        return this.isVisible;
    }
}
